/** Subtitle when structured metric data is not available (loading / legacy). */
export const BODY2_DEFAULT = 'Compared to last week';

/**
 * Normalizes dashboard metric values that may be either the new shape
 * { count, totalCount, percentage } or a legacy primitive (string/number).
 */
export const normalizeMetric = (metric) => {
  if (metric != null && typeof metric === 'object' && !Array.isArray(metric)) {
    const hasShape = 'percentage' in metric || 'count' in metric || 'totalCount' in metric;
    if (hasShape) {
      return {
        count: Number(metric.count ?? metric.retained) || 0,
        totalCount: Number(metric.totalCount) || 0,
        percentage: Number(metric.percentage) || 0,
      };
    }
    return null;
  }
  return null;
};

export const formatPercentDisplay = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return '0%';
  if (Number.isInteger(n)) return `${n}%`;
  return `${n.toFixed(2)}%`;
};

export const formatCountOfTotal = (count, totalCount) =>
  `${count.toLocaleString()} / ${totalCount.toLocaleString()}`;
